import { render, staticRenderFns } from "./Restriction.vue?vue&type=template&id=9eff3246&scoped=true&"
import script from "./Restriction.vue?vue&type=script&lang=js&"
export * from "./Restriction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eff3246",
  null
  
)

export default component.exports